import React from 'react';
import Icon, { Size } from '../icon/icon';
import Button from 'lj_shared/button/button';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  onConfirm?: () => void;
  onClose: () => void;
  confirmButtonType?: 'confirm' | 'exit';
  confirmButtonText: string;
  cancelButtonText?: string;
  confirmButtonUrl?: string;
  className?: string;
}

export default function ConfirmationModal(props: ConfirmationModalProps) {
  const styles = require('./ConfirmationModal.module.scss');

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      props.onClose();
    }
  };

  const handleConfirm = (e: React.MouseEvent) => {
    if (props.onConfirm) {
      props.onConfirm();
    }
  };

  if (!props.isOpen) return null;

  return (
    <div
      className={`${styles.backdrop} ${props.className}`}
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>{props.title}</h2>
          <button onClick={props.onClose} className={styles.closeButton} type="button">
            <Icon color="black" name="close" size={Size.MediumBig} />
          </button>
        </div>

        <div className={styles.content}>
          <p className={styles.description}>{props.description}</p>
        </div>

        <div className={styles.footer}>
          <Button
            isButton={true}
            onClick={props.onClose}
            otherClasses={styles.cancelButton}
            otherClassesOnly={true}
          >
            {props.cancelButtonText || 'Cancel'}
          </Button>
          <Button
            isButton={!props.confirmButtonUrl}
            buttonUrl={props.confirmButtonUrl}
            onClick={handleConfirm}
            otherClasses={props.confirmButtonText.toLowerCase() === 'confirm' ? styles.confirmButton : styles.exitButton}
            otherClassesOnly={true}
          >
            {props.confirmButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}